import React, { useEffect, useState } from "react";
import { useAxiosContext } from "../../../context/AxiosContext";
import Button from "../../../components/FormComponents/Button";
import MultiSelectBox from "../../../components/FormComponents/MultiSelectBox";

const SubFormSettings = ({ subFormSettingData, onClose, tableId }) => {
  // Initialize settings from subFormSettingData or provide default values
  const initialSettings = subFormSettingData.current?.settings || { allow_add: [], allow_delete: [] };
  const [settings, setSettings] = useState(initialSettings);
  const { handleError, axiosInstance } = useAxiosContext();
  const [options, setOptions] = useState([]);

  const fetchStateMachine = async () => {
    try {
      let { data } = await axiosInstance.get(`/state-machine/${tableId}`);
      data = data.config;
      const allActivities = data.activities.map((act) => ({ id: act.id, name: act.name }));
      setOptions(allActivities);
    } catch (error) {
      handleError(error);
    }
  };

  const saveFormSettings = () => {
    const tempObj = { settings: settings };
    subFormSettingData.current = tempObj;
    onClose();
  };

  const handleAddandDelete = (key, data) => {
    const idOnlyData = data.map((item) => item.id);
    setSettings((prevState) => ({ ...prevState, [key]: idOnlyData }));
  };

  // Get objects from ids
  const getValueData = (key) => {
    return options.filter((option) => settings[key]?.includes(option.id));
  };

  useEffect(() => {
    fetchStateMachine();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="builder_form">
      <MultiSelectBox
        options={options || []}
        selectedData={getValueData("allow_add")}
        onChange={(data) => handleAddandDelete("allow_add", data)}
        label="Allow adding for activities "
      />
      <MultiSelectBox
        options={options || []}
        selectedData={getValueData("allow_delete")}
        onChange={(data) => handleAddandDelete("allow_delete", data)}
        label="Allow deleting for activities"
      />
      <Button onClick={saveFormSettings}>Edit</Button>
    </div>
  );
};

export default SubFormSettings;
